(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nzc-draft-assets"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var thumbnail = event.target.closest('[data-nzc-thumb]');
    if (thumbnail) {
      var mainImage = document.querySelector('.nzc-gallery__main img');
      if (mainImage) {
        mainImage.src = thumbnail.getAttribute('data-nzc-src');
        mainImage.alt = thumbnail.getAttribute('data-nzc-alt') || mainImage.alt;
      }
    }
  });
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-nzc-variant-select]')) return;
    var option = event.target.options[event.target.selectedIndex];
    var price = document.querySelector('[data-nzc-price]');
    var button = document.querySelector('[data-nzc-add]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (button) button.disabled = option.dataset.available !== 'true';
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nzc-kit-helmet-size"] && !Shopify.designMode) return;
  try {
    (() => {
    const panel = document.querySelector('[data-nzc-kit-helmet]');
    const form = panel?.closest('form');
    if (!form) return;
    const variantSelect = form.querySelector('[name="id"]');
    const sizeSelect = panel.querySelector('select');
    const modelInput = panel.querySelector('input[type="hidden"]');
    const measurement = panel.querySelector('[data-helmet-measurement]');
    const sync = () => {
      const active = Boolean(variantSelect.value) && (panel.dataset.helmetMode === 'included' || /with helmet/i.test(variantSelect.selectedOptions[0]?.textContent || ''));
      panel.hidden = !active;
      sizeSelect.disabled = !active;
      sizeSelect.required = active;
      modelInput.disabled = !active;
      if (measurement) {
        measurement.disabled = !active;
        measurement.required = active;
        if (!active) measurement.value = '';
      }
      if (!active) sizeSelect.value = '';
    };
    document.addEventListener('variant:change', sync);
    variantSelect.addEventListener('change', sync);
    sync();
  })();
  } catch(e) { console.error(e); }
})();

})();
